// Columnas del Excel para Incoterms.
export const columnsExcel = [
  { key: 'codigo', header: 'Código' },
  { key: 'nombre', header: 'Nombre' },
  { key: 'version', header: 'Versión' },
  { key: 'descripcion', header: 'Descripción' },
  { key: 'estado', header: 'Estado' },
  { key: 'updatedAt', header: 'Última actualización' },
];
